import React from "react";
import { Radio, Headphones, PlayCircle, AudioLines, Apple, Smartphone, Speaker, Globe, RadioTower, Music, Compass, Link as LinkIcon, ArrowUpRight } from "lucide-react";
import { LISTEN_LINKS } from "../mock";
import { usePlayer } from "../context/PlayerContext";

const ICONS = { Radio, Headphones, PlayCircle, AudioLines, Apple, Smartphone, Speaker, Globe, RadioTower, Music, Compass, Link: LinkIcon };

const Luisterlinks = () => {
  const { play } = usePlayer();

  return (
    <div className="min-h-screen">
      <section className="relative overflow-hidden pt-40 pb-24">
        <div className="absolute -top-40 left-1/2 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-white/25 blur-3xl" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8 text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full glass-tint px-4 py-1.5 text-sm font-semibold text-white">
            <Headphones className="h-4 w-4" /> Overal luisteren
          </span>
          <h1 className="mt-6 font-heading text-5xl font-extrabold text-white sm:text-6xl">Luisterlinks</h1>
          <p className="mx-auto mt-6 max-w-xl text-lg text-white/90">Luister naar All-In Radio waar en wanneer je maar wilt. Kies je favoriete manier.</p>
        </div>
      </section>

      <section className="pb-28">
        <div className="mx-auto max-w-5xl px-5 sm:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {LISTEN_LINKS.map((l) => {
              const Icon = ICONS[l.icon] || Radio;
              const isWeb = l.id === "web";
              const Wrapper = isWeb ? "button" : "a";
              const props = isWeb
                ? { onClick: play, type: "button" }
                : { href: l.href, target: "_blank", rel: "noopener noreferrer" };
              return (
                <Wrapper
                  key={l.id}
                  {...props}
                  data-testid={`listen-link-${l.id}`}
                  className="group flex h-full flex-col rounded-2xl bg-[#4288F5] border border-white/15 p-5 text-left shadow-[0_18px_40px_-22px_rgba(8,30,80,0.5)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#4f92f7]"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white ring-1 ring-white/25 transition-colors group-hover:bg-white group-hover:text-[#1E6BE6]">
                      <Icon className="h-6 w-6" />
                    </span>
                    <ArrowUpRight className="h-5 w-5 shrink-0 text-white/60 transition-colors group-hover:text-white" />
                  </div>
                  <p className="mt-4 font-heading font-bold text-white">{l.name}</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/75">{l.desc}</p>
                </Wrapper>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Luisterlinks;
